import Cookies from 'js-cookie';

export default function useCsrfToken(): string {
  const cookieName = 'RequestVerificationToken';
  const token = Cookies.get(cookieName) ?? '';
  if (!token) {
    throw new Error(`no CSRF token found in cookie "${cookieName}"`);
  }
  return token;
}
